import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Version } from '../../../modules/models/version';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { TranslateService } from 'ng2-translate';

import { ProjectsService } from '../services/projects.service';
import { AlertManagerService } from '../../../shared/services/alert-manager.service';

import { Sprint, Story } from '../../models';
declare var $: any;

@Component({
  selector: 'app-modal-component-assign',
  templateUrl: './modal-component-assign.component.html',
})
export class ModalComponentAssignComponent implements OnInit {

  @Input() projectId: number;
  @ViewChild('componentModal') componentModal: ElementRef;

  componentList: Array<any> = [];
  projectComponentList: Array<any> = [];
  isAssigne: Array<boolean> = [];

  constructor(
    private formBuilder: FormBuilder,
    private projectsService: ProjectsService,
    private alertService: AlertManagerService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
  }

  openComponentModal() {
    this.getComponents(true);
    this.getProjectComponents();
  }

  setIsAssigne(projectComponents: any) {
    projectComponents.forEach(element => {
      this.isAssigne[element.id] = true;
    });
  }

  assigneComponents(component: any) {
    this.projectsService.assignComponentToProject(this.projectId, { components: [component.id] }).subscribe(
      project => {
        this.isAssigne[component.id] = true;
        this.getProjectComponents();
        this.alertService.success({ title: "", msg: this.translate.instant("COMPENENT_ADD") });
      }
    );
  }

  removeComponents(component: any) {
    this.projectsService.removeComponents(this.projectId, component.id).subscribe(
      res => {
        this.isAssigne[component.id] = false;
        this.getProjectComponents();
        this.alertService.success({ title: "", msg: "Successfull" });
      }
    );
  }

  getProjectComponents() {
    this.projectsService.getProjectComponents(this.projectId).subscribe(
      result => {
        this.projectComponentList = result.data;
        this.setIsAssigne(this.projectComponentList);
      });
  }

  getComponents(isOpen: boolean) {
    this.projectsService.getComponents().subscribe(
      result => {
        this.componentList = result.data;
        if (isOpen) {
          $(this.componentModal.nativeElement).modal({ backdrop: 'static', keyboard: false })
          $(this.componentModal.nativeElement).modal('show');
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/work/modal/modal-component-assign.component.ts